import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Breadcrumbs, PageHero, SERVICE_AREAS, SITE_ORIGIN, SiteLayout, useLeadModal, useSEO } from "./shared";

export default function ServiceAreas() {
  useSEO(
    "Fire Protection Service Areas Across Tripura | SecureFlame Fire Systems",
    "SecureFlame Fire Systems, based in Agartala, provides fire alarm, hydrant, sprinkler, extinguisher and AMC services across all 8 districts of Tripura.",
    {
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_ORIGIN}/` },
            { "@type": "ListItem", position: 2, name: "Service Areas", item: `${SITE_ORIGIN}/service-areas` },
          ],
        },
      ],
    }
  );
  const { openQuote } = useLeadModal();

  return (
    <SiteLayout>
      <PageHero
        eyebrow="Service Areas"
        title="Fire Protection Services Across Tripura"
        subtitle="Based in Agartala, SecureFlame provides site assessment, installation, testing and AMC support for fire protection systems across all 8 districts of Tripura."
      />

      <section className="max-w-7xl mx-auto px-6 py-14 md:py-20">
        <Breadcrumbs items={[{ label: "Service Areas" }]} />

        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="service-areas-grid">
          {SERVICE_AREAS.map((d) => (
            <Link
              key={d.slug}
              to={`/service-areas/${d.slug}`}
              className="group p-6 rounded-sm border border-border bg-card hover:border-primary/40 hover:shadow-lg transition-all duration-200"
              data-testid={`service-area-card-${d.slug}`}
            >
              <MapPin className="text-primary mb-3" size={22} />
              <h3 className="font-heading font-bold text-base text-secondary">{d.name}</h3>
              <p className="mt-1 text-xs text-muted-foreground">District HQ: {d.hq}</p>
              <span className="mt-3 text-sm font-semibold text-primary flex items-center gap-1.5 group-hover:gap-2.5 transition-all">
                View Details <ArrowRight size={14} />
              </span>
            </Link>
          ))}
        </div>
      </section>

      <section className="bg-secondary text-white">
        <div className="max-w-4xl mx-auto px-6 py-14 text-center">
          <h2 className="font-heading font-bold text-2xl sm:text-3xl tracking-tight">Not Sure Which District You're In?</h2>
          <p className="mt-3 text-slate-300 max-w-xl mx-auto">Get in touch directly — our team covers every district of Tripura for fire protection design, installation and AMC support.</p>
          <Button onClick={() => openQuote()} size="lg" className="mt-6 rounded-sm bg-primary hover:bg-primary/90 font-semibold" data-testid="service-areas-quote-btn">GET A QUOTE</Button>
        </div>
      </section>
    </SiteLayout>
  );
}
